// Versione "lite" del filtro temporale per la home di gojjobet (logica jamibet, template lite).
import {h, Component} from 'preact';
import MenuTimeFilter from "../../jamibet/desktop-components/menu-time-filter.jsx";

import * as P from "./templates-sports.jsx";

export default class MenuTimeFilterComponent extends MenuTimeFilter {
	render() {
		return <P.TimeFilterHolder>
			{this.getButtons().map(tab => (
				<P.TimeFilterBtn
				  onClick={e => {this.setTimeFilter(tab.value)}}
				  active={this.getCurrentFilter() == tab.value}>
					{tab.name}
				</P.TimeFilterBtn>
			))}
		</P.TimeFilterHolder>
	}
}
